module.exports = __webpack_public_path__ + "img/left_arrow.d8e237de.svg";